import { useQuery } from "@tanstack/react-query";
import TopBar from "@/components/top-bar";
import CircularLoading from "@/components/circular-loading";
import { UserService } from "@/services/user-service";
import { useProfileStore } from "@/store/profile-store";
import { generateGradientFromId } from "@/utils/gradient";
import ProfileEditForm, {
  USER_INFO_QUERY_KEY,
} from "@/features/profile/components/profile-edit-form";

export default function ProfileEditPage() {
  const profile = useProfileStore((s) => s.profile);

  const { data: userResp, isPending } = useQuery({
    queryKey: USER_INFO_QUERY_KEY,
    queryFn: () => UserService.getCurrentUser(),
    refetchOnWindowFocus: false,
    networkMode: "offlineFirst",
    staleTime: 0,
    refetchOnMount: "always",
  });
  const user = userResp?.data ?? null;

  if (isPending) {
    return (
      <div className="bg-secondary-background min-h-svh">
        <TopBar title="ویرایش اطلاعات" altHref="/profile" />
        <CircularLoading />
      </div>
    );
  }

  return (
    <div className="bg-secondary-background min-h-svh pb-28">
      <TopBar title="ویرایش اطلاعات" altHref="/profile" />

      <ProfileEditForm
        user={user}
        submitLayout="sticky"
        headerSlot={
          <div className="flex flex-col items-center px-4 pb-10 pt-6">
            <div
              className="mb-3 flex size-36 items-center justify-center rounded-[2rem] shadow-card"
              style={{ background: generateGradientFromId(profile?.id || 1) }}
            >
              {profile?.avatar ? (
                <img
                  src={profile.avatar}
                  alt="avatar"
                  width={160}
                  height={160}
                  className="size-full rounded-[2rem] object-cover"
                  loading="lazy"
                  decoding="async"
                />
              ) : null}
            </div>            
          </div>
        }
      />
    </div>
  );
}
